import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Window from "../2/Controls/Window";

class LoyaltyTypeList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            list: [],
            totalCount: 0,
            loading: false,

            page: 1,
            pageSize: 25,
            showDelete: false,

            selectedRow: null,

            listPageSettings: {

                Title: "Loyalty Type",

                Search: {
                    showSearch: false
                },

                HeaderButtons: [
                    {
                        ButtonType: "Button",
                        Type: "primary",
                        Text: "New",
                        Icon: "add",
                        Action: "new"
                    },
                ],

                Columns: [
                    {
                        Name: "Loyalty Type",
                        Type: "field",
                        Columns: [{ Column: "LoyaltyType" }],
                    },
                    {
                        Name: "Details",
                        Type: "multiple",
                        Columns: [
                            { Column: "RangeFrom", Label: "Range From" },
                            { Column: "RangeTo", Label: "Range To" },
                            { Column: "PurchaseAmount", Label: "Purchase Amount" },
                            {
                                Column: "PurchasePointValidity",
                                Label: "Purchase Point Validity",
                            },
                            { Column: "MinPurchaseValue", Label: "Min Purchase Value" },
                            {
                                Column: "PurchasePointMax",
                                Label: "Purchase Point Max Points",
                            },
                            { Column: "BirthdayPoint", Label: "Birthday Points" },
                            { Column: "Validity", Label: "Birthday Points Validity" },
                            { Column: "AnniversaryPoint", Label: "Anniversary Points" },
                            {
                                Column: "AnniversaryPointValidity",
                                Label: "Anniversary Points Validity",
                            },
                        ],
                    },
                    {
                        Name: "Details",
                        ShowInMobile: true,
                        Type: "multiple",
                        Columns: [
                            { Column: "LoyaltyType" },
                            { Column: "RangeFrom", Label: "Range From" },
                            { Column: "RangeTo", Label: "Range To" },
                            { Column: "PurchaseAmount", Label: "Purchase Amount" },
                            {
                                Column: "PurchasePointValidity",
                                Label: "Purchase Point Validity",
                            },
                            { Column: "MinPurchaseValue", Label: "Min Purchase Value" },
                            {
                                Column: "PurchasePointMax",
                                Label: "Purchase Point Max Points",
                            },
                            { Column: "BirthdayPoint", Label: "Birthday Points" },
                            { Column: "Validity", Label: "Birthday Points Validity" },
                            { Column: "AnniversaryPoint", Label: "Anniversary Points" },
                            {
                                Column: "AnniversaryPointValidity",
                                Label: "Anniversary Points Validity",
                            },
                        ],
                    },
                ],

                RowButtons: [
                    {
                        ButtonType: "ImageButton",
                        Type: "edit",
                        Text: "Edit",
                        Icon: "edit"
                    },
                    {
                        ButtonType: "ImageButton",
                        Type: "delete",
                        Text: "Delete",
                        Icon: "delete"
                    }
                ]
            }
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {

        this.setState({ loading: true });

        try {

            let allLoyatyTypes = await this.props.getLoyaltyType();

            let loyaltyTypes = allLoyatyTypes.filter((e) => !e.IsDeleted);

            this.setState({
                list: loyaltyTypes,
                totalCount: loyaltyTypes.length,
                loading: false,
                page: 1
            });

        }
        catch (error) {

            console.error(error);

            this.setState({
                loading: false
            });

        }

    };

    // =====================
    // PAGINATION
    // =====================

    onNextClick = () => {

        const totalPages = Math.ceil(
            this.state.totalCount / this.state.pageSize
        );

        if (this.state.page < totalPages) {

            this.setState({
                page: this.state.page + 1
            });

        }

    };

    onPreviousClick = () => {

        if (this.state.page > 1) {

            this.setState({
                page: this.state.page - 1
            });

        }

    };

    onFirstClick = () => {

        this.setState({
            page: 1
        });

    };

    onLastClick = () => {

        const totalPages = Math.ceil(
            this.state.totalCount / this.state.pageSize
        );

        this.setState({
            page: totalPages
        });

    };

    onRecordsPerPageCountChange = (size) => {

        this.setState({
            pageSize: Number(size),
            page: 1
        });

    };

    // =====================
    // HEADER BUTTON
    // =====================

    onHeaderButtonClicked = (btn) => {

        if (btn.Action === "new") {

            this.props.history.push("/home/loyalty/new");

        }

    };

    // =====================
    // ROW BUTTONS
    // =====================

    onRowButtonClicked = (btn, row) => {

        if (btn.Type === "edit") {

            this.props.history.push(`/home/loyalty/edit/${row.key}`);

        }

        if (btn.Type === "delete") {

            this.setState({
                showDelete: true,
                selectedRow: row
            });

        }

    };

    // =====================
    // DELETE
    // =====================

    deleteRecord = async () => {

        this.setState({
            showDelete: false,
            loading: true
        });

        await this.props.deleteLoyaltyType(
            this.state.selectedRow.key
        );

        this.setState({
            loading: false,
            selectedRow: null
        });

        this.loadData();

    };


    onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};
    render() {

        return (

            <>

                <ListingPage

                    {...this.props}

                    listPageSettings={{
                        ...this.state.listPageSettings,
                    }}
onPageChange={this.onPageChange}
                    list={
                        this.state.list.slice(
                            (this.state.page - 1) * this.state.pageSize,
                            this.state.page * this.state.pageSize
                        )
                    }

                    loading={this.state.loading}

                    totalItemsCount={this.state.totalCount}

                    recordFrom={
                        (this.state.page - 1) * this.state.pageSize
                    }

                    itemsCountPerPage={this.state.pageSize}

                    onNextClick={this.onNextClick}

                    onPreviousClick={this.onPreviousClick}

                    onFirstClick={this.onFirstClick}

                    onLastClick={this.onLastClick}

                    onRecordsPerPageCountChange={
                        this.onRecordsPerPageCountChange
                    }

                    onHeaderButtonClicked={
                        this.onHeaderButtonClicked
                    }

                    onRowButtonClicked={
                        this.onRowButtonClicked
                    }

                />

                {this.state.showDelete && (

                    <Window

                        header="Delete"

                        modal

                        onClose={() =>
                            this.setState({
                                showDelete: false
                            })
                        }

                        onButtonClick={(btn) => {

                            if (btn === "Yes")
                                this.deleteRecord();

                            else
                                this.setState({
                                    showDelete: false
                                });

                        }}

                        buttons={[
                            {
                                Type: "secondary",
                                Text: "No",
                                Align: "left"
                            },
                            {
                                Type: "primary",
                                Text: "Yes",
                                Align: "right"
                            }
                        ]}

                    >

                        Are you sure you want to delete?

                    </Window>

                )}

            </>

        );

    }

}

export default LoyaltyTypeList;